<template>
  <CircleSpinner v-if="eventsLoading || kiosksLoading" />
  <div v-show="!eventsLoading && !kiosksLoading" data-testid="page-booking-selection">
    <TabBar v-model="activeTab" :tabs="tabItems" class="w-11/12 max-w-56" @input="changeTab" />
    <div v-if="activeTab == 'current'" class="w-full text-center">
      <template v-if="!eventsResult?.events?.nodes?.length">
        <img src="/assets/images/festival-shop-no-items.svg" class="mx-auto" />
        <p class="mt-4 txt-headline-s">{{ t('FestivalShop.StartPage.noUpcomingBookings') }}</p>
      </template>
      <MessageBanner v-if="!hasKiosks" class="mt-6" type="warning" :message="t('FestivalShop.StartPage.noKiosksCurrent')" />
      <KiosksByEvent v-for="event in eventsResult?.events?.nodes" :key="event?.id" :event="event" :kiosks="kiosks" :is-past="false" />
    </div>
    <div v-else>
      <MessageBanner type="neutral" :message="t('FestivalShop.StartPage.pastOrdersInfo')" />
      <MessageBanner v-if="!hasKiosks" class="mt-6" type="warning" :message="t('FestivalShop.StartPage.noKiosksPast')" />
      <KiosksByEvent v-for="event in eventsResult?.events?.nodes" :key="event?.id" :event="event" :kiosks="kiosks" :is-past="true" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { CircleSpinner, TabBar, MessageBanner } from '@ramp106/omrjs-core-ui'
import { computed, ref, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute, useRouter } from 'vue-router'

import { KiosksByEvent } from '@/components/FestivalShop/'
import { useEventsQuery, useFestivalShopKiosksQuery, EventPeriodEnum, type FestivalShopKiosksQuery } from '@/gql/myomr'

const route = useRoute()
const router = useRouter()
const { t } = useI18n()
const period = computed(() => (route.query.period == 'past' ? EventPeriodEnum.Past : EventPeriodEnum.Upcoming))

const tabItems = computed(() => [
  {
    id: 'current',
    name: t('FestivalShop.StartPage.tabCurrent'),
  },
  {
    id: 'past',
    name: t('FestivalShop.StartPage.tabPast'),
  },
])

const activeTab = ref('current')

const { result: eventsResult, loading: eventsLoading } = useEventsQuery(() => ({ period: period.value }))
const { result: kiosksResult, loading: kiosksLoading } = useFestivalShopKiosksQuery(() => ({ period: period.value, limit: 30 }))

type KioskNode = FestivalShopKiosksQuery['festivalShopKiosks']['nodes'][number]
const kiosks = computed<KioskNode[]>(() => kiosksResult.value?.festivalShopKiosks?.nodes ?? [])
const hasKiosks = computed(() => kiosks.value.length > 0)

function changeTab(newSelectedTab: string) {
  if (newSelectedTab == 'current') return router.push({ query: { period: undefined } })
  return router.push({ query: { period: 'past' } })
}

onMounted(() => {
  if (route.query.period == 'past') activeTab.value = 'past'
})
</script>
